/* 布局 */
//前台
import Layout from "@views/layout";

const plachargeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "placharge/list",
        name: "PLACHARGE",
        meta: {
            title: "收费管理",
        },
        component: () => import("@views/business/placharge/index.vue"),
    },
        ],
};

export default plachargeRouter;
